import { useMemo } from 'react';
import { matchPath, useLocation, useRouteMatch } from 'react-router-dom';

import * as ROUTES from 'constants/routes.js';

const routeEntries = Object.entries(ROUTES).filter(([, route]) => typeof route === 'string');
const routesAsArray = routeEntries.map(([, route]) => route);

export const getRouteKey = (path) => routeEntries.find(([, route]) => route === path)?.[0] ?? null;

// Several constants can match one page: aliases with the same path, and
// generic patterns such as ORG_BASE_ROUTE next to the specific one.
export const getMatchingRouteKeys = (pathname) => routeEntries
  .filter(([, route]) => matchPath(pathname, { path: route, exact: true }))
  .map(([key]) => key);

/**
 * Matches the current location against every ROUTES constant. `routeKey` is the
 * name of the first matching constant (e.g. ORG_SHOWS), `routeKeys` the names
 * of all of them, together with the first match itself.
 */
const useCurrentRouteKey = () => {
  const { pathname } = useLocation();
  const matchingPath = useRouteMatch({ path: routesAsArray, exact: true });
  const { params, path, url } = matchingPath || {};
  const routeKeys = useMemo(() => getMatchingRouteKeys(pathname), [pathname]);

  return { routeKey: getRouteKey(path), routeKeys, params, path, url };
};

export default useCurrentRouteKey;
